import React from 'react';
import { Ad } from 'Components/atoms/Ad';

/**
 * Ad: Out of page
 * @returns {*}
 * Returns four Out of Page Ad Components
 */
export const getOOPAds = () => {
  const oops = ['oop_1', 'oop_2', 'oop_3', 'oop_4'];

  return oops.map(element => (
    <Ad
      id={`ad_${element}`}
      key={`ad_${element}`}
      targeting={{
        position: element,
        placement: element,
        refresh: 'no',
      }}
      outOfPage
    />
  ));
};
